import { Array2d } from '@cibo/core/src/utils/geometry'
import { Feature, FeatureCollection, MultiPolygon, Polygon } from 'geojson'
import { useMemo } from 'react'
import { findEditorOverlaps } from './findEditorOverlaps'

export const useEditorOverlaps = (
  features: FeatureCollection<Polygon | MultiPolygon>,
  testShapes?: Feature<any, { boundingBox: Array2d }>[]
) => {
  const overlaps = useMemo(() => {
    if (!features.features?.length || !testShapes) return

    return findEditorOverlaps({ featureCollection: features, testShapes })
  }, [features, testShapes])

  return {
    isReady: true,
    overlaps,
  }
}
